import {$wrapSelectionInMarkNode, MarkNode, SerializedMarkNode} from '@lexical/mark';
import {$applyNodeReplacement, LexicalNode, NodeKey, RangeSelection, Spread} from 'lexical';

import styles from './PlaceholderNode.module.css';

export type SerializedPlaceholderNode = Spread<
  {
    className?: string;
  },
  SerializedMarkNode
>;

export class PlaceholderNode extends MarkNode {
  __className?: string;

  static getType(): string {
    return 'placeholder-mark';
  }

  static importDOM(): null {
    return null;
  }

  static clone(node: PlaceholderNode): PlaceholderNode {
    return new PlaceholderNode([...node.__ids], node.__className, node.__key);
  }

  constructor(ids: string[], className?: string, key?: NodeKey) {
    super(ids, key);
    this.__className = className;
  }

  createDOM(): HTMLElement {
    const span = document.createElement('span');
    span.classList.add(styles.placeholder);
    span.setAttribute('data-placeholder-id', this.__ids[0]);

    return span;
  }

  updateDOM(): boolean {
    return false;
  }

  exportJSON(): SerializedPlaceholderNode {
    return {
      ...super.exportJSON(),
      type: 'placeholder-mark',
      version: 1,
      className: this.__className,
    };
  }

  static importJSON(serializedNode: SerializedPlaceholderNode): PlaceholderNode {
    return new PlaceholderNode(serializedNode.ids, serializedNode.className);
  }
}

export function $createPlaceholderNode(id: string, className?: string): PlaceholderNode {
  return $applyNodeReplacement(new PlaceholderNode([id], className));
}

export function $wrapSelectionInPlaceholderNode(
  selection: RangeSelection,
  id: string,
  className?: string
) {
  $wrapSelectionInMarkNode(selection, false, id, () => $createPlaceholderNode(id, className));
}

export function $isPlaceholderNode(node: LexicalNode | null | undefined): node is PlaceholderNode {
  return node instanceof PlaceholderNode;
}
